import axios from 'axios'
import {store} from '../store/store'
import router from '../../router'

/**
 * @type Rest2
 */
export default class Rest2 {


    constructor(bearer_token=null,base='/api/v1'){
      
        this.path = base

        let _headers = {};
        _headers['Access-Control-Allow-Origin'] = '*';
        _headers['Content-Type'] = 'application/json';

        if(bearer_token!=null){
            _headers['Authorization'] = 'Bearer '+bearer_token;
        }

        this.http = axios.create({
            baseURL: process.env.VUE_APP_BASE_URL,
            timeout: 10000000,
            transformResponse: [
              function (data) {                      
                if(!data || data.error_code){
                  store.commit('token', false);
                  router.push({name:'login'});
                  return false;
                }
                return data;
              }
            ],
            responseType: 'json',  
            headers: _headers
          });

        return this;
    }

  /**
   * @param {String} path
   * @param {Object} options
   * @param {Object} http
   * @return {this}
   */
  static build (token, path = '', options = {}) {
    return new this(token, this.normalize('/api/v1', path), options)
  }

  /**
   * @param {String} url
   * @returns {*|Promise<any>}
   */
  get (url) {      
    return this.http
      .get(this.constructor.normalize(this.path, url))
      .then(this.constructor.then)
  }

    /**
   * @param {String} url
   * @returns {*|Promise<any>}
   */
  delete (url) {      
    return this.http
      .delete(this.constructor.normalize(this.path, url))
      .then(this.constructor.then)
  }

  /**
   * @param {String} url
   * @param {Object} data
   * @returns {*|Promise<any>}
   */
  post (url, data,http_options={}) {
    return this.http
      .post(this.constructor.normalize(this.path, url), data,http_options)
      .then(this.constructor.then)
  }

  postFormData (url, data, config) {
    if(config==null){
      config = {headers: { 'Content-Type': 'multipart/form-data',  'Access-Control-Allow-Origin':'*'}};
    }
    config.timeout = 6000000;
    return this.http
      .post(this.constructor.normalize(this.path, url), data, config)
      .then(this.constructor.then)
  }

  /**
   * @param {Object} response
   * @returns {Object}
   */
  static then (response) {
    if (!response.data) {
      return {}
    }
    if (typeof response.data === 'string') {
      return JSON.parse(response.data)
    }
    return response.data
  }

  
  /**
   * @param {String} start
   * @param {String} end
   * @returns {String}
   */
  static normalize (start, end) {
    return `${start}/${end}`.replace(/([^:]\/)\/+/g, '$1')
  }
}
